<template>
  <div class="embed-website-container">
    <!-- 触发按钮 -->
    <div @click="toggleEmbed" class="open-button">
      <ChatBubble />
    </div>
    
    <!-- 遮罩层 -->
    <transition name="fade">
      <div 
        v-if="isVisible" 
        class="embed-overlay"
        @click="toggleEmbed"
      ></div>
    </transition>
    
    <!-- 嵌入网站容器 -->
    <transition name="scale">
      <div 
        v-if="isVisible" 
        class="embed-wrapper"
        @click.stop
      >
        <iframe 
          :src="embeddedUrl" 
          class="embedded-site"
          frameborder="0"
          allowfullscreen
          sandbox="allow-same-origin allow-scripts allow-modals allow-forms allow-popups allow-presentation"
          allow="clipboard-write; camera; microphone"
        ></iframe>
        <button @click="toggleEmbed" class="close-button">×</button>
      </div>
    </transition>
  </div>
</template>

<script>
import ChatBubble from '../components/home/ChatBubble.vue'
export default {
  components:{
    ChatBubble
  },
  data() {
    return {
      isVisible: false,
      embeddedUrl: 'https://human.qrspx.cn' // 替换为你想要嵌入的网站URL
    }
  },
  methods: {
    toggleEmbed() {
      this.isVisible = !this.isVisible
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.embed-website-container {
  position: fixed;
  right:50px;
  bottom:30%;
  z-index:9999;
}

/* 按钮样式 */
/* .open-button {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.open-button:hover {
  background-color: #45a049;
} */

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  line-height: 30px;
  cursor: pointer;
  z-index: 10;
}

.close-button:hover {
  background-color: #d32f2f;
}

/* 遮罩层样式 */
.embed-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

/* 嵌入网站容器样式 */
.embed-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1000px;
  height: 600px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  z-index: 101;
  overflow: hidden;
}

.embedded-site {
  width: 100%;
  height: 100%;
  border: none;
}

/* 过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.scale-enter-active, .scale-leave-active {
  transition: all 0.3s ease;
}
.scale-enter, .scale-leave-to {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.8);
}
</style>